import { render, staticRenderFns } from "./MTips.vue?vue&type=template&id=33ebaba5&"
import script from "./MTips.vue?vue&type=script&lang=ts&"
export * from "./MTips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports